function initMegaMenus() {
  document.querySelectorAll('.js-megamenu:not(.is-init)').forEach(menu => {
    const index = menu.dataset.index;
    if (!index) return;

    const target = document.querySelector(`.js-nav-item[data-index="${index}"]`);
    if (!target) return;

    target.appendChild(menu);
    menu.classList.add('is-init');

    menu.addEventListener('focusin', () => {
      target.classList.add('active');
    });

    menu.addEventListener('focusout', (event) => {
      if (!menu.contains(event.relatedTarget)) {
        target.classList.remove('active');
      }
    });
  });
}

document.addEventListener('focusin', (event) => {
  const activeNav = document.querySelector('.js-nav-item.active');
  if (!activeNav) return;

  const mega = activeNav.querySelector('.js-megamenu');
  if (!mega) return;

  if (!mega.contains(event.target) && !activeNav.contains(event.target)) {
    activeNav.classList.remove('active');
  }
});

document.addEventListener('DOMContentLoaded', initMegaMenus);
document.addEventListener('shopify:section:load', initMegaMenus);

document.addEventListener('shopify:block:select', (event) => {    
  document.querySelectorAll('.js-nav-item.active').forEach(item => {
    item.classList.remove('active');
  });

  initMegaMenus();

  const blockId = event.detail.blockId;

  let el = document.querySelector(`[data-block-id="${blockId}"]`);

  if (!el) return;

  const mega = el.closest('.js-megamenu');
  if (!mega) return;

  const index = mega.dataset.index;
  if (!index) return;

  const navItem = document.querySelector(`.js-nav-item[data-index="${index}"]`);
  if (!navItem) return;

  navItem.classList.add('active');
});